import LabelledDivRow from "components/LabelledDivRow";
import Tag from "components/Tag/Tag";
import moment from "moment";
import React from "react";
import { formatWrittenDateTimeUtc } from "utilities";

interface Props {
  exchangeRate: server.dto.ExchangeRateDiagnostic
}

const ExchangeRateRows = ({ exchangeRate }: Props) => {
  const lastSyncMoment = moment.utc(exchangeRate.lastRefresh);
  const fromNow = lastSyncMoment.fromNow();
  return <>
    <LabelledDivRow label="Last refresh">
      <div>
        <Tag
          title={fromNow}
          label={formatWrittenDateTimeUtc(lastSyncMoment)}
          color={exchangeRate.hasProblem ? "red" : "green"}
        />
      </div>
    </LabelledDivRow>
    <LabelledDivRow label="Provider">
      <a href={exchangeRate.providerWebsite} target="_blank" rel="noreferrer">{exchangeRate.providerWebsite}</a>
    </LabelledDivRow>
  </>;
};

export default ExchangeRateRows;